import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { APPLICATION_STATE, ViewModes } from 'shared-lib'
import { CandidateTagFilterKeys } from '../shared/application-search'

@Injectable({
  providedIn: 'root',
})
export class CandidateListService {
  private viewModeSource$ = new BehaviorSubject<{ mode: ViewModes; selectedStatus?: APPLICATION_STATE }>({ mode: ViewModes.Swimlane })

  viewMode$ = this.viewModeSource$.asObservable()

  constructor() {}

  setViewMode(mode: ViewModes, status?: APPLICATION_STATE) {
    this.viewModeSource$.next({ mode, selectedStatus: status })
  }

  static getOrderedApplicationStates(): APPLICATION_STATE[] {
    return [
      APPLICATION_STATE.APPLIED,
      APPLICATION_STATE.SCREENED,
      APPLICATION_STATE.INTERVIEWING,
      APPLICATION_STATE.FINALIST,
      APPLICATION_STATE.OFFER_SENT,
      APPLICATION_STATE.HIRED,
      APPLICATION_STATE.UNRESPONSIVE,
      APPLICATION_STATE.NOT_INTERESTED,
      APPLICATION_STATE.WITHDRAWN,
    ]
  }

  toggleFilterTags(tagFilters: CandidateTagFilterKeys[], value: CandidateTagFilterKeys) {
    if (tagFilters.includes(value)) {
      return tagFilters.filter(key => key != value)
    }

    return [...tagFilters, value]
  }
}
